(function($) {
    'use strict';

    var $carousel = $('[gr-carousel]');
    var $carouselBrand = $('[gr-carousel-brand]');
    var $carouselTestimonials = $('[gr-carousel-testimonials]');
    var $carouselGallery = $('[gr-carousel-gallery]');
    var $carouselGalleryContainer = $('[gr-carousel-gallery-container]')
    var $galleryToCarousel = $('[gr-gallery-to-carousel]');


    if($carousel) {
        $carousel.slick({
            arrows: true,
            dots: true,
            dotsClass: 'carousel__indicators',
            prevArrow: '<button class="carousel__arrow carousel__prev"><span class="icon-angle-left"></span></button>',
            nextArrow: '<button class="carousel__arrow carousel__next"><span class="icon-angle-right"></span></button>',
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 8000
        });
    }

    if($carouselTestimonials) {
        $carouselTestimonials.slick({
            arrows: true,
            dotsClass: 'carousel__indicators',
            prevArrow: '<button class="carousel__arrow carousel__prev"><span class="icon-angle-left"></span></button>',
            nextArrow: '<button class="carousel__arrow carousel__next"><span class="icon-angle-right"></span></button>',
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 16000
        });
    }

    if($carouselBrand) {
        $carouselBrand.slick({
            arrows: true,
            prevArrow: '<button class="carousel__arrow carousel__prev"><span class="icon-angle-left"></span></button>',
            nextArrow: '<button class="carousel__arrow carousel__next"><span class="icon-angle-right"></span></button>',
            slidesToShow: 5,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    /**
     * Gallery to carousel
     */
    
    if($galleryToCarousel) {
        $carouselGalleryContainer.hide();
    
        $galleryToCarousel.each(function() {
            var $images = $(this).find('[gr-image-trigger]');
            var $i = 0;
            if($images && $carouselGallery) {
                $images.each(function(){
                    $(this).attr('data-position', $i);

                    // click on image
                    $(this).click(function() {
                        $carouselGallery.empty();
                        $images.each(function() {
                            // copy all images from same group in carousel
                            $(this)
                                .clone()
                                .appendTo($carouselGallery);
                        });

                        // add slider
                        $carouselGallery.slick({
                            arrows: true,
                            dots: true,
                            dotsClass: 'carousel__indicators',
                            prevArrow: '<button class="carousel__arrow carousel__prev"><span class="icon-angle-left"></span></button>',
                            nextArrow: '<button class="carousel__arrow carousel__next"><span class="icon-angle-right"></span></button>',
                            slidesToShow: 1,
                            autoplay: false,
                            fade: true,
                            cssEase: 'linear',
                            adaptiveHeight: true,
                            initialSlide: $(this).data('position'),
                            lazyLoad:'progressive'
                        });
                        $carouselGalleryContainer.show();
        
                        // fermeture carousel
                        $carouselGalleryContainer
                            .on('click', function(e) {
                                // exclusion de l'image et de ces boutons
                                if(e.target == $('.slick-track')[0] || 
                                    e.target == $('[class *= "carousel__prev"]')[0] ||
                                    e.target == $('[class *= "carousel__next"]')[0] ||
                                    e.target == $('[class *= "icon-angle-right"]')[0] ||
                                    e.target == $('[class *= "icon-angle-left"]')[0] ||
                                    e.target.type == 'button') {
                                    return
                                }
                                $carouselGalleryContainer.hide();
                                $carouselGallery.slick('unslick'); 
                            });
                    })
                    $i++;
                })

            }
            
        })
    }

})(jQuery);
